import { render, staticRenderFns } from "./arealuqu.vue?vue&type=template&id=202d51b5&scoped=true"
import script from "./arealuqu.vue?vue&type=script&lang=js"
export * from "./arealuqu.vue?vue&type=script&lang=js"
import style0 from "./arealuqu.vue?vue&type=style&index=0&id=202d51b5&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d51b5",
  null
  
)

export default component.exports